import { Navigate, Outlet } from "react-router-dom";

import { ROUTES } from "@/constants/routes";
import { useAuth } from "@/lib/hooks/useAuth";

const PrivateRoute: React.FC = () => {
  const { accessToken } = useAuth();

  if (!accessToken) {
    return <Navigate to={ROUTES.login} replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
